"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAddIcon = exports.StyledCheckmarkWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
const list_row_item_styles_1 = require("../list-row-item/list-row-item.styles");
exports.StyledCheckmarkWrapper = (0, styled_components_1.default)(list_row_item_styles_1.StyledListRowItemMark) `
    border: ${({ $isStrategized }) => ($isStrategized ? 'none' : `1px solid ${ui_components_1.baseColors.primaryBlueMed200}`)} ;
    transition: border-color .3s ease;
`;
exports.StyledAddIcon = (0, styled_components_1.default)(ui_components_1.Icon) `
    svg {
        width: 25px;
        height: 25px;
        transform: translate(-2px, -2px);
        opacity: 0;
        transition: opacity .3s ease;
    }

    &:hover {
        cursor: pointer;

        svg {
            opacity: 1;
        }
    }
`;
